import { TagStruct } from "src/app/shared/components/tag/tag.struct";
import { PrescriptionMedicine } from "../../models/pharmacy/prescription-medicine.model";
import { MaterialItemKitRequests } from "../../requests/pharmacy/request-material.request";
import { KitWithItemsStruct } from "./kit-with-items.struct";
import { PrescriptionMedicineCheckStruct } from "./prescription-medicine-check.struct";

export class PrescriptionMedicineStruct {
    public prescriptionMedicine: PrescriptionMedicine = new PrescriptionMedicine();

    public listPrescriptionMedicineCheck: PrescriptionMedicineCheckStruct[] = [];
    public listKit: KitWithItemsStruct[] = [];
    public listMaterialItemKitRequests: MaterialItemKitRequests[] = [];

    public idEpisode: number;
    public idNextPrescriptionMedicineCheck: number;
    public countMeasurementUnit: number;
    public idRoom: number;
    public idSector: number;
    public idUser: number;
    public idMultiProfessionalCare: number;
    public idMedicalCare: number;
    public quantityReleased: number;
    public frequencyValue: number;
    public subFrequencyValue: number;
    public calculatedDispensationQuantity: number;

    public lookupAdministrationLocationName: string;
    public medicineName: string;
    public usage: string;
    public administrationTypeName: string;
    public presentationName: string;
    public frequencyName: string;
    public treatmentPeriodName: string;
    public dilutionName: string;
    public subFrequencyName: string;
    public dilutionUnitName: string;
    public measurementUnitName: string;
    public doseToAdministeredName: string;
    public roomLocation: string;
    public userName: string;
    public prescriptionStatus: string;
    public medicNameSuspended: string;
    public nurseNameSuspended: string;
    
    public patientHasAllergy: boolean;
    public controlledMedicine: boolean;

    public datetimeInclusion: Date;

    //variáveis somente para o front
    public isChecked: boolean = false;
    public hasReport: boolean = false;
    public selectForDispensing: boolean = false;
    public isSelectedSector: boolean;
    public prescriptionChecked: boolean = false;
    public canSuspend: boolean;
    public tempCheck: boolean;

    public listSelectedIdKit: number[] = [];
    listTags: TagStruct[] = [];
    public tagsTooltipText: string;
}